<template lang="html">
  <div class="mask">
    <div class="popup">
      <h3> <img src="../../assets/icons/gift-popup-ok.svg"/> 赠送成功 </h3>

      <div class="operation">
        <button class="confirm" @click="$emit(confirmEvent)">知道了</button>
        <button class="begin" @click="$emit(beginEvent)">继续赠送</button>
        <div class="sep"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GiveSuccess',

  props: ['confirmEvent', 'beginEvent']
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

.mask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 9999;
  background-color: rgba(0,0,0,.5);

  .popup {
    position: absolute;
    top: rem(509);
    left: 0; right: 0;
    height: rem(300);
    width: rem(540);
    margin: 0 auto;
    background-color: #fff;
    border-radius: rem(4);

    h3 {
      margin-top: rem(84);
      margin-bottom: rem(75);
      height: rem(50);
      text-align: center;
      font-size: rem(36);
      line-height: rem(50);

      img {
        height: rem(50);
        width: rem(50);
        margin-right: rem(20);
        line-height: rem(50);
        vertical-align: middle;
      }
    }

    .operation {
      height: rem(90);
      width: 100%;
      border-top: rem(1) solid #E4E4E4;

      .confirm,
      .begin {
        height: 100%;
        width: 50%;
        font-size: rem(32);
        border: none;
        outline: none;
        background-color: #fff;
      }

      .begin {
        color: #F48F00;
      }

      .sep {
        position: absolute;
        bottom: 0;
        left: 0; right: 0;
        margin: 0 auto;
        height: rem(89);
        width: 1px;
        background-color: #E4E4E4;
      }
    }
  }
}
</style>
